const updateEventData = {
    backGroundType: "testBackgroundType", 
    eventCategory:"TestCategory"
}

export default updateEventData;